module.exports = __webpack_public_path__ + "img/paci_en_3.3ca74d76.png";